module.exports = __webpack_public_path__ + "static/media/iconfinder_Folder-Archive-zip-icon_88567.79c7fc09.png";